module.exports = __webpack_public_path__ + "static/media/agalerija_2023 (37).3120719a.png";